// carrierUtils.js (if mapping directly by id)
export const carrierMappings = {
  "+9378": { id: 1, name: "e& Afghanistan" },
  "+9373": { id: 1, name: "e& Afghanistan" },
  "+9379": { id: 2, name: "Roshan" },
  "+9372": { id: 2, name: "Roshan" },
  "+9374": { id: 3, name: "Salaam" },
  "+9377": { id: 4, name: "Atoma" },
  "+9376": { id: 4, name: "Atoma" },
  "+9371": { id: 5, name: "AWCC" },
  "+9370": { id: 5, name: "AWCC" },
  "+93750": { id: 6, name: "Wasel" },
  "+9375": { id: 7, name: "Cdma" },

  "+977986": { id: 8, name: "NTC" },
  "+977984": { id: 8, name: "NTC" },
  "+977982": { id: 9, name: "NCell" },
  "+977981": { id: 9, name: "NCell" },
  "+977980": { id: 9, name: "NCell" },

  "+9050": { id: 11, name: "Vodafone" },
  "+9051": { id: 11, name: "Vodafone" },
  "+9053": { id: 12, name: "Turkcell" },
  "+9054": { id: 12, name: "Turkcell" },
  "+9055": { id: 12, name: "Turkcell" },
  "+9056": { id: 13, name: "Avea" },
  "+9059": { id: 13, name: "Avea" },
};

export const mapPhoneNumberToCarrier = (phoneCode, phoneNumber="") => {
  const fullPhoneNumber = `${phoneCode}${phoneNumber}`;

  const sortedPrefixes = Object.keys(carrierMappings).sort((a, b) => b.length - a.length);

  const matchingPrefix = sortedPrefixes.find((prefix) => fullPhoneNumber.startsWith(prefix));

  return matchingPrefix ? carrierMappings[matchingPrefix] : null;
};

export const getAsaanCarrier = () => {
  return { id: 14, name: "Asaan" };
};
